import { Dialog } from '@ordr-as/umami-react/dialog';
import { useState } from 'react';
import { useQueryBanner } from '../hooks/useBannerApi';

type Props = {
  locationId: string;
};

const getStoredClosedDate = (type?: string) => {
  if (!type) {
    return undefined;
  }

  const key = 'banner-' + type;

  const value = localStorage.getItem(key);

  if (value === null) {
    return undefined;
  }

  return new Date(parseInt(value, 10));
};

const Banner = ({ locationId }: Props) => {
  const { data: bannerDto } = useQueryBanner(locationId);
  const storedClosedDate = getStoredClosedDate(bannerDto?.type);
  const [closedDate, setClosedDate] = useState<Date | undefined>(storedClosedDate);
  const hasBeenClosed = closedDate && closedDate.getTime() + 3600000 > Date.now();
  const showBanner = bannerDto?.shouldShowBanner && !hasBeenClosed;

  const onClose = () => {
    if (!bannerDto) {
      return;
    }

    localStorage.setItem('banner-' + bannerDto.type, Date.now().toString());
    setClosedDate(new Date());
  };

  if (!showBanner) {
    return <></>;
  }

  return (
    <>
      <Dialog
        backdrop={false}
        className="bg-orange-light fixed bottom-0 w-[400px] "
        title="Account alert"
        onClose={onClose}
        isDismissable={false}
      >
        <p>
          Your account is past due. Please make a payment to avoid service interruption. Already paid? It may take a few
          days to process.
          <a className=" ml-1 bold underline" rel="noreferrer" href="https://support.favrit.com" target="_blank">
            Need help?
          </a>
        </p>
      </Dialog>
    </>
  );
};

export default Banner;
